import { ClientResponse } from '@commercetools/platform-sdk';
import sortBy from 'lodash/sortBy';

import { ctApi } from '@/api';
import {
  CustomProductProjectionSearch,
  CustomProductProjectionSearchResponse,
} from '@/graphql/customProducts';
import { NutsProductProjection } from '@/utils/productProjection';
import { reportError } from '@/utils/reportError';

export async function fetchGreetingCards(): Promise<NutsProductProjection[]> {
  const response = (await ctApi
    .graphql()
    .post({
      body: {
        query: CustomProductProjectionSearch,
        variables: {
          customProductKey: ['Greeting Card'],
        },
      },
    })
    .execute()) as unknown as ClientResponse<CustomProductProjectionSearchResponse>;

  const { results } = response.body.data.productProjectionSearch;

  const greetingCards: NutsProductProjection[] = [];
  results.forEach((result) => {
    try {
      greetingCards.push(NutsProductProjection.fromQueryResult(result));
    } catch (error) {
      reportError(error);
    }
  });

  return sortBy(greetingCards, 'orderHint');
}
